import merchantService from "./merchantService";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import { Dispatch } from "redux";
import Merchant from "domain/merchant";
import { Fee } from "domain/fee";
import { CustomField } from "domain/customField";
import PaymentOptionDetails from "domain/paymentOptionDetails";

export class MerchantAutoOfferUpdated extends Event {
    constructor(public enabled: boolean) {
        super(MerchantAutoOfferUpdated.EventName);
    }

    public static EventName: string = "merchants/auto-offer-updated";
}

export class MerchantPassOnFillUpdated extends Event {
    constructor(public enabled: boolean) {
        super(MerchantPassOnFillUpdated.EventName);
    }

    public static EventName: string = "merchants/pass-on-fill-updated";
}

export class MerchantAutoPositionUpdated extends Event {
    constructor(public enabled: boolean) {
        super(MerchantAutoPositionUpdated.EventName);
    }

    public static EventName: string = "merchants/auto-position-updated";
}

export class MerchantsLoaded extends Event {
    constructor(public merchants: Merchant[]) {
        super(MerchantsLoaded.EventName);
    }

    public static EventName: string = "merchants/all-loaded";
}

export class MerchantFeesLoaded extends Event {
    constructor(public fees: Fee[]) {
        super(MerchantFeesLoaded.EventName);
    }

    public static EventName: string = "MERCHANT_FEES_LOADED";
}

export class MerchantCustomFieldsLoaded extends Event {
    constructor(public customFields: CustomField[]) {
        super(MerchantCustomFieldsLoaded.EventName);
    }

    public static EventName: string = "MERCHANT_CUSTOM_FIELDS_LOADED";
}

export class MerchantPaymentOptionsLoaded extends Event {
    constructor(public paymentOptionDetails: PaymentOptionDetails[]) {
        super(MerchantPaymentOptionsLoaded.EventName);
    }

    public static EventName: string = "MERCHANT_PAYMENT_OPTIONS_LOADED";
}

export function updateAutoOffer(enabled: boolean): ActionWithDispatch<Promise<any>> {
    return function (dispatch: any) {
        return merchantService
            .updateAutoOffer(enabled)
            .then(dispatch(new MerchantAutoOfferUpdated(enabled).toObject()));
    };
}

export function updatePassOnFill(enabled: boolean): ActionWithDispatch<Promise<any>> {
    return function (dispatch: any) {
        return merchantService
            .updatePassOnFill(enabled)
            .then(dispatch(new MerchantPassOnFillUpdated(enabled).toObject()));
    };
}

export function updateAutoPosition(enabled: boolean): ActionWithDispatch<Promise<any>> {
    return function (dispatch: any) {
        return merchantService
            .updateAutoPosition(enabled)
            .then(dispatch(new MerchantAutoPositionUpdated(enabled).toObject()));
    };
}

export async function loadAllMerchants(dispatch: Dispatch<any>) {
    const merchants = await merchantService.listAllMerchants();
    dispatch(new MerchantsLoaded(merchants).toObject());
}

export function loadMerchantFees(): ActionWithDispatch<Fee[]> {
    return function(dispatch: any) {
      return merchantService.listFees()
        .then(fees =>
          dispatch(new MerchantFeesLoaded(fees).toObject())
        );
    };
}

export function loadMerchantCustomFields(dispatch: Dispatch): Promise<CustomField[]> {
    return merchantService.listCustomFields()
        .then(cf => dispatch(new MerchantCustomFieldsLoaded(cf).toObject()));
}

export function loadMerchantPaymentOptions(dispatch: Dispatch): Promise<PaymentOptionDetails[]> {
    return merchantService.listPaymentOptions()
        .then(pod => dispatch(new MerchantPaymentOptionsLoaded(pod).toObject()));
}